
import EnhancedProfessionalDashboard from "@/components/professional/dashboard/enhanced/EnhancedProfessionalDashboard";

const ProfessionalDashboard = () => {
  return <EnhancedProfessionalDashboard />;
};

export default ProfessionalDashboard;
